// extracted by mini-css-extract-plugin
module.exports = {"efBacktop":"backtop_efBacktop__dlBmW"};